import ExtractionProperties from './ExtractionProperties';
export default ExtractionProperties;